import RepositoryFactory from '@/services/repository-factory';

const BannersRepository = RepositoryFactory.get('banners');

export default {
  fetchBanners({
    dispatch,
  }, payload = {}) {
    const {
      places,
      ensure = true,
    } = payload;

    return BannersRepository.fetch({ places })
      .then((response) => {
        if (places?.includes('private_offers')) {
          dispatch('setPrivateOffersBanners', response);
        } else {
          dispatch('setBanners', response);

          if (ensure) {
            dispatch('ensureAllBannersExist', response);
          }

          dispatch('sortingBanners', 'all');
        }
      });
  },
  updateBanner({
    state,
    dispatch,
  }, {
    successNotify,
    errorNotify,
  }) {
    dispatch('setLoading', true);
    BannersRepository.update(state.activeBanner)
      .then((response) => {
        dispatch('setBanner', response);
        dispatch('setLoading', false);
        successNotify();
      })
      .catch(() => {
        dispatch('setLoading', false);
        errorNotify();
      });
  },
  setLoading({ commit }, boolean) {
    commit('SET_LOADING', boolean);
  },
  ensureAllBannersExist({
    state,
    commit,
  }, fetchedBanners) {
    const bannersMap = fetchedBanners.reduce((map, banner) => {
      map[banner.place] = banner;

      return map;
    }, {});

    state.bannersInfo.forEach((info) => {
      const { place } = info;

      if (!bannersMap[place]) {
        commit('ADD_BANNER', place);
      }
    });
  },
  setBanner({ commit }, banner) {
    if (banner.place === 'private_offers') {
      commit('SET_PRIVATE_OFFERS_BANNER', banner);
    } else {
      commit('SET_BANNER', banner);
    }
  },
  setActiveBanner({ commit }, index) {
    commit('SET_ACTIVE_BANNER', index);
  },
  setActiveBannerId({ commit }, index) {
    commit('SET_ACTIVE_BANNER_ID', index);
  },
  setActivePlace({ commit }, index) {
    commit('SET_ACTIVE_PLACE', index);
  },
  addInformationToBanner({ commit }) {
    commit('UPDATE_BANNER');
  },
  deleteBannerSettings({ commit }, obj) {
    if (obj.id) {
      BannersRepository.delete({ id: obj.id })
        .then(() => {
          commit('DELETE_BANNER_SETTINGS', obj.index);
        });
    } else {
      commit('DELETE_BANNER_SETTINGS', obj.index);
    }
  },
  deletePrivateOfferBanner({ dispatch }, { id }) {
    if (!id) return;

    BannersRepository.deleteBanner({ id })
      .then(() => dispatch('fetchBanners', {
        places: ['private_offers'],
        ensure: false,
      }));
  },
  updateBannerInformation({
    state,
    dispatch,
  }) {
    if (!+state.activeBanner.informations.length) {
      dispatch('addInformationToBanner');
    } else {
      dispatch('checkTranslations');
    }
  },
  setContent({ commit }, content) {
    commit('SET_CONTENT', content);
  },
  setScrollDelay({ commit }, scrollDelay) {
    commit('SET_SCROLL_DELAY', scrollDelay);
  },
  setBannerType({ commit }, type) {
    commit('SET_TYPE', type);
  },
  setBackgroundImage({ commit }, obj) {
    commit('SET_BACKGROUND_IMAGE', obj);
  },
  setImage({ commit }, obj) {
    commit('SET_IMAGE', obj);
  },
  setBackgroundColor({ commit }, obj) {
    commit('SET_BACKGROUND_COLOR', obj);
  },
  setTitleTextColor({ commit }, obj) {
    commit('SET_TEXT_TITLE_COLOR', obj);
  },
  setTitle({ commit }, obj) {
    commit('SET_TITLE', obj);
  },
  setSubTitleTextColor({ commit }, obj) {
    commit('SET_SUBTITLE_TEXT_COLOR', obj);
  },
  setSubTitle({ commit }, obj) {
    commit('SET_SUBTITLE', obj);
  },
  setButtonTextColor({ commit }, obj) {
    commit('SET_BUTTON_TEXT_COLOR', obj);
  },
  setButtonText({ commit }, obj) {
    commit('SET_BUTTON_TEXT', obj);
  },
  setButtonBgColor({ commit }, obj) {
    commit('SET_BUTTON_BG_COLOR', obj);
  },
  setButtonLink({ commit }, obj) {
    commit('SET_BUTTON_LINK', obj);
  },
  moveUp({ commit }, index) {
    commit('MOVE_UP', index);
  },
  moveDown({ commit }, index) {
    commit('MOVE_DOWN', index);
  },
  setBannerName({ commit }, name) {
    commit('SET_BANNER_NAME', name);
  },
  sortingBanners({
    commit,
    dispatch,
  }, val) {
    commit('SET_SORTED_BANNERS', val);
    dispatch('setStatus', val);
  },
  setStatus({ commit }, val) {
    commit('SET_STATUS', val);
  },
  resetInformations({ commit }) {
    commit('RESET_BANNER_INFORMATIONS');
  },
  openCreateBannerDraftForPrivateOffers({
    state,
    dispatch,
  }) {
    dispatch('addPrivateOffersBanner', 'private_offers');
    dispatch('setSortedBannersDirect', state.privateOffersBanners);

    const index = state.privateOffersBanners.length - 1;

    dispatch('setActiveBanner', index);
    dispatch('setActiveBannerId', index);
    dispatch('setActivePlace', index);
    dispatch('addInformationToBanner');
    dispatch('checkTranslations');
  },
  async saveBanner({
    state,
    dispatch,
  }, {
    successNotify,
    errorNotify,
  } = {}) {
    try {
      dispatch('setLoading', true);

      const repository = BannersRepository;
      const saved = state.activeBanner?.id
        ? await repository.update(state.activeBanner)
        : await repository.create(state.activeBanner);

      await dispatch('setBanner', saved);
      await dispatch('fetchBanners', {
        places: ['private_offers'],
        ensure: false,
      });

      dispatch('setLoading', false);

      if (successNotify) {
        successNotify();
      }
    } catch (e) {
      dispatch('setLoading', false);

      if (errorNotify) {
        errorNotify();
      }
    }
  },
  clearActiveBanner({ commit }) {
    commit('CLEAR_ACTIVE_BANNER');
  },
  setSortedBannersDirect({ commit }, list) {
    commit('SET_SORTED_BANNERS_DIRECT', list);
  },
  setPrivateOffersBanners({ commit }, banners) {
    commit('SET_PRIVATE_OFFERS_BANNERS', banners);
  },
  setBanners({ commit }, banners) {
    commit('SET_BANNERS', banners);
  },
  addPrivateOffersBanner({ commit }, value) {
    commit('ADD_PRIVATE_OFFERS_BANNER', value);
  },
  checkTranslations({ commit }) {
    commit('CHECK_TRANSLATIONS');
  },
  copyBannerInformation({
    state, commit,
  }, index) {
    if (!state.activeBanner || !Array.isArray(state.activeBanner.informations)) {
      return;
    }

    const information = state.activeBanner.informations[index];

    if (!information) return;

    const clone = JSON.parse(JSON.stringify(information));

    if ('id' in clone) {
      delete clone.id;
    }

    if ('sorting' in clone) {
      delete clone.sorting;
    }

    commit('SET_COPIED_BANNER_INFORMATION', clone);
  },

  pasteBannerInformation({
    state,
    commit,
  }, index) {
    if (!state.copiedBannerInformation) return;

    if (!state.activeBanner || !Array.isArray(state.activeBanner.informations)) {
      return;
    }

    const buffer = JSON.parse(JSON.stringify(state.copiedBannerInformation));
    const current = state.activeBanner.informations[index] || {};
    const merged = {
      ...current,
      ...buffer,
      id: current.id,
      sorting: current.sorting,
    };

    commit('REPLACE_ACTIVE_BANNER_INFORMATION', {
      index,
      information: merged,
    });
  },
};
